export default "__VITE_ASSET__BtisPaio__"